import { FC, Suspense } from 'react';
import { Layout as BaseLayout, Grid, Image } from 'antd';
import { Outlet } from 'react-router-dom';
import { AuthContextProvider } from '../../../contexts/AuthContext';
import Vector from '../../../assets/images/vector.png';

const ActivationLayout: FC = () => {
  const { lg } = Grid.useBreakpoint();

  return (
    <AuthContextProvider>
      <BaseLayout
        style={{
          minHeight: '100vh',
          backgroundImage: `url(${Vector})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
        }}
      >
        <Suspense>
          <Outlet />
        </Suspense>
      </BaseLayout>
    </AuthContextProvider>
  );
};

export default ActivationLayout;
